export var RoutingFilterType;
(function (RoutingFilterType) {
    RoutingFilterType[RoutingFilterType["LOCALE"] = 0] = "LOCALE";
    RoutingFilterType[RoutingFilterType["SOFT_SKILL"] = 10] = "SOFT_SKILL";
    RoutingFilterType[RoutingFilterType["PRODUCT_SKILL"] = 20] = "PRODUCT_SKILL";
})(RoutingFilterType || (RoutingFilterType = {}));
//# sourceMappingURL=index.js.map